// Pre-construction luxury projects currently being marketed by the team.
// Deposits and delivery dates are illustrative.

export const projects = [
  {
    id: 'proj-mandarin-oriental',
    name: 'Mandarin Oriental Residences',
    developer: 'Swire Properties',
    architect: 'Kohn Pedersen Fox',
    interior: 'Studio Gaia',
    neighborhood: 'Brickell Key',
    city: 'Miami',
    state: 'FL',
    heroImage: 'mandarin-oriental',
    priceFrom: 5_500_000,
    priceTo: 42_000_000,
    bedsFrom: 2,
    bedsTo: 6,
    sqftFrom: 2_400,
    sqftTo: 11_800,
    depositSchedule: '10% reservation · 20% contract · 20% GB · 50% closing',
    estimatedDelivery: 'Q4 2027',
    status: 'selling',
    inventoryRemaining: 34,
    totalUnits: 228,
    amenities: [
      'Private marina with yacht slips',
      'Mandarin Oriental hotel services',
      'Spa and wellness floor',
      'Private dining by celebrity chef',
    ],
    tagline: 'Brickell Key’s crown jewel — branded residences with hotel service.',
  },
  {
    id: 'proj-st-regis',
    name: 'The St. Regis Residences Miami',
    developer: 'Related Group · Integra · Rosso',
    architect: 'Robert A.M. Stern Architects',
    interior: 'Rockwell Group',
    neighborhood: 'Brickell',
    city: 'Miami',
    state: 'FL',
    heroImage: 'st-regis',
    priceFrom: 3_900_000,
    priceTo: 25_000_000,
    bedsFrom: 2,
    bedsTo: 5,
    sqftFrom: 2_100,
    sqftTo: 8_900,
    depositSchedule: '10% · 10% · 10% · 70% closing',
    estimatedDelivery: 'Q2 2028',
    status: 'selling',
    inventoryRemaining: 58,
    totalUnits: 354,
    amenities: [
      'St. Regis Butler Service',
      'Two-acre amenity deck',
      'Private wine vault',
      'Athletic club and spa',
    ],
    tagline: 'Classic Stern architecture with St. Regis white-glove service.',
  },
  {
    id: 'proj-cipriani',
    name: 'Cipriani Residences Miami',
    developer: 'Mast Capital',
    architect: 'Arquitectonica',
    interior: '1508 London',
    neighborhood: 'Brickell',
    city: 'Miami',
    state: 'FL',
    heroImage: 'cipriani',
    priceFrom: 2_800_000,
    priceTo: 18_000_000,
    bedsFrom: 1,
    bedsTo: 5,
    sqftFrom: 1_700,
    sqftTo: 7_200,
    depositSchedule: '10% · 10% · 10% · 70% closing',
    estimatedDelivery: 'Q1 2028',
    status: 'selling',
    inventoryRemaining: 71,
    totalUnits: 397,
    amenities: [
      'Cipriani restaurant on site',
      'Members-only lounge',
      'Owner’s library',
      'Resort pool with cabanas',
    ],
    tagline: 'The first Cipriani-branded tower in the Western hemisphere.',
  },
  {
    id: 'proj-mercedes-benz',
    name: 'Mercedes-Benz Places Miami',
    developer: 'JDS Development',
    architect: 'SHoP Architects',
    interior: 'Mercedes-Benz Design',
    neighborhood: 'Downtown Miami',
    city: 'Miami',
    state: 'FL',
    heroImage: 'mercedes-benz',
    priceFrom: 1_900_000,
    priceTo: 14_500_000,
    bedsFrom: 1,
    bedsTo: 4,
    sqftFrom: 1_250,
    sqftTo: 6_400,
    depositSchedule: '10% reservation · 20% contract · 10% GB · 60% closing',
    estimatedDelivery: 'Q4 2028',
    status: 'pre-selling',
    inventoryRemaining: 512,
    totalUnits: 791,
    amenities: [
      'Signature Mercedes-Benz club level',
      'Private EV fleet for residents',
      'Sky pool on the 70th floor',
      'On-site wellness and recovery',
    ],
    tagline: 'Mercedes-Benz’s first global residential flagship.',
  },
  {
    id: 'proj-casa-bella',
    name: 'Casa Bella Residences by B&B Italia',
    developer: 'Related Group',
    architect: 'Arquitectonica',
    interior: 'Piero Lissoni · B&B Italia',
    neighborhood: 'Downtown Miami',
    city: 'Miami',
    state: 'FL',
    heroImage: 'casa-bella',
    priceFrom: 1_600_000,
    priceTo: 9_800_000,
    bedsFrom: 1,
    bedsTo: 4,
    sqftFrom: 1_050,
    sqftTo: 4_900,
    depositSchedule: '10% · 10% · 10% · 70% closing',
    estimatedDelivery: 'Q3 2027',
    status: 'selling',
    inventoryRemaining: 22,
    totalUnits: 306,
    amenities: [
      'B&B Italia furnishing package',
      'Lissoni-designed lobby and lounges',
      'Italian trattoria on site',
      'Private art and sculpture garden',
    ],
    tagline: 'Italian design curated end-to-end by Piero Lissoni.',
  },
];

export const projectById = Object.fromEntries(projects.map((p) => [p.id, p]));
